import {TEditableColumn, TFieldStateType} from 'components/editable-table/model/types';
import {IFieldMeta} from 'entities/metadata';

const createStateCell = (activityList?: any) => (): TFieldStateType => activityList || {} as TFieldStateType;

export const generateEditableMetadata = (
    cols: IFieldMeta,
): TEditableColumn => ({
    ...cols,
    dataIndex: cols.dataIndex || cols.key,
    getFieldState: createStateCell({
        required: cols.isRequired,
        dependencies: cols.dependentsFieldKey,
    }),
    inputProps: undefined,
});